export enum AgentKeyEnum {
  FAUCET = 'faucet',
  MATCH_BETS = 'match-bets',
  PAYOUT = 'payout-new',
  MONEY = 'money', // leagacy сервис payout передавал с этим agentKey, оставлен для совместимости
  PAYMENT = 'payment',
  DEPOSIT = 'deposit', // agentKey от платежной системы
  REFERRAL = 'referral',
  LEADERS_RACE = 'leaders-race',
  SEASONAL_QUESTS = 'seasonal-quests',
  INVENTORY = 'inventory',
  SHOP = 'shop',
  DOUBLE_GAME = 'double-game',
  DOUBLE_GAME_NEW = 'double-new-game',
  X50_GAME = 'x50-game',
  X50_GAME_NEW = 'x50-game-new',
  CLASSIC_GAME = 'classic-game',
  FAST_GAME = 'fast-game',
  CASES_GAME = 'cases',
  CRAFT_GAME = 'craft',
  SLOTS_GAME = 'slots',
  SLOTS_FREE = 'slots-free', // agentKey wallet-кредитов выигрышей фри-спинов slots (legacy)
  HILO_GAME = 'hilo-game',
  BACCARAT_GAME = 'baccarat-game',
  WHEEL_GAME = 'wheel',
  TOWER = 'tower', // agentKey game-result событий tower (CloudPubSub)
  TOWER_GAME = 'tower-game', // agentKey wallet-транзакций tower (legacy publish.service, nodeId tower-game)
  POGGI = 'poggi',
  POGGI_SLOTS = 'poggi-slots',
  FORTUNE_WHEEL = 'fortune-wheel',
  DOUBLE_GAME_BOOST = 'double-game--boost',
  ADMIN = 'admin',
  CRASH_GAME = 'crash-game',
  CRASH_GAME_NEW = 'crash-game-new',
  MARKET = 'market',
  CLASSIC_LOTTERY = 'classic-lottery',
  UPGRADE = 'upgrade',
  SAMURAI_GAME = 'samurai',
  CASE_BATTLES_GAME = 'case-battles',
  CASES_QUEST = 'cases-quest',
  OFFERWALL = 'offerwall',
  BONUS = 'bonus',
  WITHDRAW = 'withdraw',
  RAIN_GAME = 'rain-game',
  USER_LEVEL = 'user-level',
  RAFFLE_GAME = 'raffle-game',
  SOLITAIRE_GAME = 'solitaire-game',
  PROMO_CODE = 'promo-code',
  VIP_BONUS = 'vip-bonus',
  BET = 'bet', // agentKey денежных транзакций сервиса ставок (спортбук; провайдер-агностично)
}
